import { PureComponent, ReactNode } from 'react';
import styled from 'styled-components';

const Wrapper = styled.nav`
  display: block;
`;

const Container = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
`;

interface Props {
  children: ReactNode;
}

class NavigationLinkList extends PureComponent<Props> {
  render() {
    const { children } = this.props;
    return (
      <Wrapper>
        <Container>{children}</Container>
      </Wrapper>
    );
  }
}

export default NavigationLinkList;
